/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var PropTypes = require("prop-types");
var Input_1 = require("./Input");
var Icon_1 = require("./Icon");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Select.css'); }
var objectWithout_1 = require("./util/objectWithout");
var SelectNative = /** @class */ (function (_super) {
    tslib_1.__extends(SelectNative, _super);
    function SelectNative() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (e) {
            _this.props.onChange(e, e.target.value);
        };
        return _this;
    }
    SelectNative.prototype.wrappedChildren = function () {
        return React.Children.map(this.props.children, function (child) {
            if (!child) {
                return child;
            }
            return React.cloneElement(child, {
                native: true
            });
        });
    };
    SelectNative.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, id = _a.id, label = _a.label, name = _a.name, inputProps = tslib_1.__rest(_a, ["value", "id", "label", "name"]);
        return (React.createElement("div", { className: classnames("m-input", "m-input-" + name) },
            React.createElement("div", { className: "m-input-elementWrapper" },
                React.createElement(Input_1.Input, tslib_1.__assign({ id: id, label: label, value: value, type: "text", name: name, onChange: this.handleChange, inputClassName: "m-select-input" }, inputProps, { renderInput: function (_a // eslint-disable-line no-unused-vars
                    ) {
                        var type = _a.type, restInputProps = tslib_1.__rest(_a, ["type"] // eslint-disable-line no-unused-vars
                        );
                        return React.createElement("select", tslib_1.__assign({}, restInputProps), _this.wrappedChildren());
                    } }),
                    React.createElement(Icon_1.Icon, { type: "select", className: "m-select-chevron" })))));
    };
    SelectNative.propTypes = tslib_1.__assign({ value: PropTypes.any, placeholder: PropTypes.string, className: PropTypes.string, onChange: PropTypes.func.isRequired }, objectWithout_1.objectWithout(Input_1.Input.propTypes, ["type", "maxLength"]));
    return SelectNative;
}(React.Component));
exports.SelectNative = SelectNative;